<script setup lang="ts">
import { T } from '@tolgee/vue'
import { twMerge } from 'tailwind-merge'
import { formatDuration } from '@/helpers/date'
import { useShop } from '@/composables/game/shop'
import { Vue3Lottie } from 'vue3-lottie'
import XmasShopJson from '@/assets/lotties/periodic/christmas/xmas-shop.json'
import DefaultDiscountBadge from '@/components/periodic/default-discount/DefaultDiscountBadge.vue'
import DefaultCashbackBadge from '@/components/periodic/default-cashback/DefaultCashbackBadge.vue'
import DefaultBOGOBadge from '@/components/periodic/default-BOGO/DefaultBOGOBadge.vue'
import DefaultBOGXBadge from '@/components/periodic/default-BOGX/DefaultBOGXBadge.vue'
import IWDBadge from '@/components/periodic/IWD/IWDBadge.vue'
import STPBadge from '@/components/periodic/STP/STPBadge.vue'

const {
  isDefaultBOGO,
  isDefaultBOGX,
  isIWD,
  isSTP,
  isDefaultCashback,
  isSale,
  isDefaultDiscount,
  countdownForSaleEnds,
  canHaveSale,
} = useShop()

</script>
<template>
  <div class="relative h-[52px] w-[48px] scale-up-button translate-y-2">
    <div
      class="absolute -left-2.5 size-[38px] z-[3]"
      v-if="canHaveSale"
    >
      <DefaultDiscountBadge
        v-if="isDefaultDiscount"
      />
      <DefaultCashbackBadge
        v-else-if="isDefaultCashback"
      />
      <DefaultBOGOBadge
        v-else-if="isDefaultBOGO"
      />
      <DefaultBOGXBadge
        v-else-if="isDefaultBOGX"
      />
      <IWDBadge v-else-if="isIWD" />
      <STPBadge v-else-if="isSTP" />
    </div>
    <div
      :class="twMerge('flex justify-center rounded-[15px] shop-button pulse-shadow px-[7px] pt-1.5 pb-2 translate-y-2.5',
                      canHaveSale && isDefaultDiscount && 'pulse-shadow-default-discount',
                      isDefaultBOGO && 'pulse-shadow-default-BOGO',
                      isDefaultCashback && 'pulse-shadow-default-cashback',
                      isIWD && 'IWD-background pulse-shadow-IWD',
                      isSTP && 'STP-background pulse-shadow-STP',
      )"
      style="background: linear-gradient(90deg, #A50000 0%, #E11023 68.53%, #FC1833 100%);"
    >
      <div class="w-full h-full relative flex justify-center z-[2]">
        <!--        <Vue3Lottie-->
        <!--          v-if="canHaveSale && isIWD"-->
        <!--          :animation-data="IWDShopJson"-->
        <!--          :auto-play="true"-->
        <!--          :loop="true"-->
        <!--          width="100%"-->
        <!--          height="auto"-->
        <!--          class="min-w-full"-->
        <!--        />-->
        <!--        <Vue3Lottie-->
        <!--          v-else-if="canHaveSale && isSTP"-->
        <!--          :animation-data="STPShopJson"-->
        <!--          :auto-play="true"-->
        <!--          :loop="true"-->
        <!--          width="100%"-->
        <!--          height="auto"-->
        <!--          class="min-w-full"-->
        <!--        />-->
        <Vue3Lottie
          :animation-data="XmasShopJson"
          :auto-play="true"
          :loop="true"
          width="100%"
          height="auto"
          class="min-w-full"
        />
      </div>
    </div>
    <div
      class="absolute left-1/2 -translate-x-1/2 h-[18px] px-1.5 top-[48px] rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-dark-top-most-layer whitespace-nowrap"
    >
      <span
        v-if="canHaveSale && isSale"
        :class="countdownForSaleEnds < (3600 * 12) && 'text-red-accent'"
      >
        {{ formatDuration(countdownForSaleEnds, undefined, countdownForSaleEnds > (3600 * 72)) }}
      </span>
      <span v-else>
        <T
          key-name="tap.shop"
          default-value="Shop"
        />
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/sales.scss';

.gradient-container::before {
	content: '';
	position: absolute;
	inset: 0;
	background: linear-gradient(90deg, #FFD65B 0%, #FF0000 50%, rgba(255, 214, 91, 40) 100%);
	-webkit-mask: linear-gradient(white, white) padding-box,
	linear-gradient(black, black) content-box;
	mask: linear-gradient(white, white) padding-box,
	linear-gradient(black, black) content-box;
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	z-index: 2;
	border-radius: 15px; /* Match the container's border radius */
	padding: 2.5px; /* Stroke width */
}

.gradient-container {
	//background:linear-gradient(105deg, #FFCB00 10.46%, #B57800 61.24%, #B77C07 70.47%, #BF881B 82.01%, #CB9D3C 95.86%, #DCB96A 112.01%, #F1DDA5 130.48%, #FFF4C9 139.71%, #EACE88 153.55%, #D8AD4E 167.4%, #CB9423 178.94%, #C38509 188.17%, #C08000 192.79%, #C58500 197.41%, #EAB200 227.41%, #F9C300 241.26%);
	background: #FA5A24;
}

@keyframes scale-up-button {
	from {
		transform: scale(1);
	}
	to {
		transform: scale(1.03);
	}
}

.scale-up-button {
	animation: scale-up-button 0.75s ease infinite alternate;
	will-change: transform;
}

.shop-button::before {
	background: rgba(255, 255, 255, 40%);
	border-radius: 15px;
	content: "";
	inset: 0;
	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	padding: 2px; /* this is the border width */
	position: absolute;
	z-index: 10;
	pointer-events: none;
}

</style>